<template>
  <div>
    <div class="row">
      <a-divider>{{ $t('inscription.selectionnerModePaiement') }}</a-divider>

      <div class="col-lg-3">
        <h6>{{ $t("inscription.fraisInscri") + " (" + currency + ")" }}</h6>
        <p>{{ activity.inscription }}</p>
      </div>
      <div
        @click="$emit('change-mode', 'M')"
        :class="[
          'col-lg-4',
          'mr-2',
          'pt-2',
          mode === 'M' ? 'custom-border-active' : 'custom-border',
        ]"
      >
        <h6>{{ $t("inscription.fraisMensuel") + " (" + currency + ")" }}</h6>
        <p>{{ activity.monthly }}</p>
      </div>
      <div
        v-if="activity.tranches && activity.tranches.length"
        @click="$emit('change-mode', 'T')"
        :class="[
          'col-lg-4',
          'pt-2',
          mode === 'T' ? 'custom-border-active' : 'custom-border',
        ]"
      >
        <h6>{{ $t('inscription.fraisDesTranches') + " (" + currency + ")" }}</h6>
        <li v-for="t in activity.tranches" :key="t.trancheNumber">
          {{ $t('inscription.tranche') + " " + t.trancheNumber + " : " + t.amount }}
        </li>
      </div>
      <a-alert
        width="100%"
        class="mt-2"
        :message="
          $t('inscription.modePaiementSelectionne') + ' ' +
          (mode === 'T' ? $t('inscription.parTranches') : $t('inscription.mensuelle'))
        "
        type="info"
        show-icon
      />
      <a-divider>{{ $t('inscription.lesFraisAPayer') }}</a-divider>
    </div>
    <div class="row">
      <div class="col-lg-9 mb-2">
        <div v-for="(value, key, index) in includedFees" :key="key">
          <div class="row mt-1">
            <div class="col-6">
              <a-form-item
                :class="index == 0 ? 'mt-0 mb-0' : 'm-0'"
                :label="index == 0 ? $t('inscription.frais') : ''"
              >
                <a-tag style="width: 100%; font-size: 15px" class="mt-1"
                  >{{ formatFeeName(key, false) }}
                </a-tag>
              </a-form-item>
            </div>
            <div class="col-6">
              <a-form-item
                :class="index == 0 ? 'mt-0 mb-0' : 'm-0'"
                :label="index == 0 ? $t('inscription.inclus') : ''"
              >
                <a-switch
                  :checked="value"
                  @change="(e) => $emit('toggle-fee', key, e)"
                >
                  <a-icon slot="checkedChildren" type="check" />
                  <a-icon slot="unCheckedChildren" type="close" />
                </a-switch>
              </a-form-item>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { formatFeeName } from "@/utilities/settings";
import { getBuildingCurrency } from "@/utilities/countrySpecific";

export default {
  name: "MonthlyFeesSection",
  props: {
    activity: {
      type: Object,
      default: () => ({}),
    },
    mode: {
      type: String,
      default: "M",
    },
    includedFees: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      currency: getBuildingCurrency(),
    };
  },
  methods: {
    formatFeeName,
  },
};
</script>
<style scoped>
.custom-border {
  border: 1px solid #6c757d;
  border-radius: 0.25rem;
  cursor: pointer;
}
.custom-border-active {
  border: 3px solid #22bb33;
  border-radius: 0.25rem;
  cursor: pointer;
}
</style>
